module.exports = __webpack_public_path__ + "img/icon12.8148cdf.png";